module.exports = __webpack_public_path__ + "img/4.ecaef339.png";